import { createClient } from '@supabase/supabase-js'

// Configuração do cliente Supabase
const supabaseUrl = 'https://xtkorgedlxwfuaqyxguq.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inh0a29yZ2VkbHh3ZnVhcXl4Z3VxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQwMDY4NDMsImV4cCI6MjA0OTU4Mjg0M30.oMQTNvIdtIHsFgSGczo6fWEOGsOCWJkENKOzPrXrP8c'
export const supabase = createClient(supabaseUrl, supabaseKey)

// Função para buscar a disponibilidade do produto
export const fetchAvailability = async (productId) => {
  try {
    const { data, error } = await supabase
      .from('bianca_produtos')
      .select('disponibilidade, data_e_hora_agendamentos')
      .eq('product_id', productId)
      .single();
    
    if (error) {
      console.error('Erro ao buscar disponibilidade:', error);
      return null;
    }
    
    return {
      disponibilidade: data?.disponibilidade || null,
      agendamentos: data?.data_e_hora_agendamentos || null
    };
  } catch (error) {
    console.error('Erro ao buscar disponibilidade:', error);
    return null;
  }
};

// Função para salvar os dados do agendamento
export const saveAppointment = async (appointmentData) => {
  try {
    const { data, error } = await supabase
      .from('agendamentos')
      .insert([
        {
          nome: appointmentData.name,
          email: appointmentData.email,
          telefone: appointmentData.phone,
          data: appointmentData.date,
          horario: appointmentData.timeSlot,
          product_id: 'PmQn6l5kpfCBhF5Z',
          status: 'agendado'
        }
      ]);
    
    if (error) {
      console.error('Erro ao salvar agendamento:', error);
      return { success: false, error };
    }
    
    return { success: true, data };
  } catch (error) {
    console.error('Erro ao salvar agendamento:', error);
    return { success: false, error };
  }
};

// Função para parsear a string de disponibilidade em um objeto estruturado
export const parseAvailability = (availabilityString, bookedSlotsString) => {
  if (!availabilityString) return {};
  
  console.log('Parsing availability string:', availabilityString);
  
  const daysAvailability = {};
  
  // Processa os slots já agendados
  const bookedSlots = parseBookedSlots(bookedSlotsString);
  
  // Divide a string por dias (separados por pontos)
  const dayStrings = availabilityString.split('.');
  console.log('Day strings:', dayStrings);
  
  dayStrings.forEach(dayString => {
    if (!dayString || dayString.trim() === '') return;
    
    // Divide cada dia em nome e slots
    const colonIndex = dayString.indexOf(':');
    if (colonIndex === -1) {
      console.error('Formato inválido para dayString (sem dois pontos):', dayString);
      return;
    }
    
    let dayName = dayString.substring(0, colonIndex);
    const slotsString = dayString.substring(colonIndex + 1);
    
    // Substituir os nomes dos dias com "-feira" por versões mais curtas
    dayName = dayName.replace('Segunda-feira', 'Segunda')
                    .replace('Terça-feira', 'Terça')
                    .replace('Quarta-feira', 'Quarta')
                    .replace('Quinta-feira', 'Quinta')
                    .replace('Sexta-feira', 'Sexta');
    
    console.log('Day name:', dayName, 'Slots string:', slotsString);
    
    // Verifica se o dia está disponível
    if (slotsString === 'indisponível') {
      daysAvailability[dayName] = [];
    } else {
      // Divide os slots (separados por ponto e vírgula)
      const slots = slotsString.split(';');
      console.log('Slots for', dayName, ':', slots);
      
      // Filtra os slots já agendados
      const availableSlots = slots.filter(slot => {
        // Verifica se este slot está disponível (não agendado)
        const dateString = formatDateString(dayName);
        return !isSlotBooked(dateString, slot, bookedSlots);
      });
      
      daysAvailability[dayName] = availableSlots;
    }
  });
  
  console.log('Parsed availability:', daysAvailability);
  return daysAvailability;
};

// Função para formatar a string de data
const formatDateString = (dayName) => {
  // Converte o nome do dia para uma data real
  // Este é um exemplo simples - você precisará adaptar para suas necessidades
  const today = new Date();
  const dayMap = {
    'Segunda': 1, 'Terça': 2, 'Quarta': 3, 'Quinta': 4, 'Sexta': 5, 'Sábado': 6, 'Domingo': 0
  };
  
  const dayDiff = (dayMap[dayName] - today.getDay() + 7) % 7;
  const targetDate = new Date(today);
  targetDate.setDate(today.getDate() + dayDiff);
  
  // Formata como DD/MM/YYYY
  const day = String(targetDate.getDate()).padStart(2, '0');
  const month = String(targetDate.getMonth() + 1).padStart(2, '0');
  const year = targetDate.getFullYear();
  
  return `${day}/${month}/${year}`;
};

// Função para analisar os slots já agendados
const parseBookedSlots = (bookedSlotsString) => {
  if (!bookedSlotsString) return [];
  
  // Divide a string por ponto e vírgula para obter cada agendamento
  const bookings = bookedSlotsString.split(';');
  
  // Processa cada agendamento para extrair data e horário
  return bookings.map(booking => {
    const parts = booking.trim().split(', ');
    if (parts.length !== 2) return null;
    
    return {
      date: parts[0].trim(),
      timeSlot: parts[1].trim()
    };
  }).filter(booking => booking !== null);
};

// Função para verificar se um slot está agendado
const isSlotBooked = (dateString, timeSlot, bookedSlots) => {
  return bookedSlots.some(booking => 
    booking.date === dateString && booking.timeSlot === timeSlot
  );
};

// Função para obter o nome do dia da semana em português
export const getDayName = (date) => {
  // Se a data for uma string, apenas retorna ela mesma
  if (typeof date === 'string') {
    return date;
  }
  
  const days = [
    'Domingo',
    'Segunda',
    'Terça',
    'Quarta',
    'Quinta',
    'Sexta',
    'Sábado'
  ];
  
  return days[date.getDay()];
};

// Função para verificar se uma data está no passado
export const isPastDate = (date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  return date < today;
};

// Função para verificar se uma data é hoje
export const isToday = (date) => {
  const today = new Date();
  
  return date.getDate() === today.getDate() &&
         date.getMonth() === today.getMonth() &&
         date.getFullYear() === today.getFullYear();
};

// Função para verificar se um horário já passou (para o dia de hoje)
export const isTimeSlotPassed = (timeSlot) => {
  if (!isToday(new Date())) return false;
  
  const now = new Date();
  const [startHour, startMinute] = timeSlot.split('-')[0].split(':').map(Number);
  
  const slotTime = new Date();
  slotTime.setHours(startHour, startMinute, 0, 0);
  
  return now > slotTime;
};
